(function () {
  function addStyles() {
    if (document.getElementById('readmore-product-tab-styles')) return;
    var style = document.createElement('style');
    style.id = 'readmore-product-tab-styles';
    style.textContent = '' +
      '.readmore-book-details-tab{max-width:760px;}' +
      '.readmore-book-details-tab dl{display:grid;grid-template-columns:minmax(150px,auto) 1fr;gap:10px 24px;margin:0;}' +
      '.readmore-book-details-tab dt{font-weight:600;color:rgb(var(--heading-color));}' +
      '.readmore-book-details-tab dd{margin:0;}' +
      '.readmore-reviews-empty{margin:0;color:rgb(var(--color-body));}' +
      '@media(min-width:741px){' +
        '.shopify-section--product-content .product-tabs__tab-item-content.rte{max-width:1000px;margin-left:auto!important;margin-right:auto!important;text-align:center!important;}' +
        '.shopify-section--product-content .product-tabs__tab-item-content.rte *{text-align:center!important;}' +
        '#block-readmore_additional_information-content{text-align:center!important;}' +
        '#block-readmore_additional_information-content .readmore-book-details-tab{max-width:760px;margin-left:auto!important;margin-right:auto!important;text-align:center!important;}' +
        '#block-readmore_additional_information-content .readmore-book-details-tab dl{grid-template-columns:repeat(2,minmax(0,260px))!important;justify-content:center;max-width:600px;margin-left:auto!important;margin-right:auto!important;}' +
        '#block-readmore_additional_information-content .readmore-book-details-tab dt,#block-readmore_additional_information-content .readmore-book-details-tab dd{text-align:center!important;}' +
      '}' +
      '@media(max-width:740px){.readmore-book-details-tab dl{grid-template-columns:120px minmax(0,1fr);gap:8px 16px;}}';
    document.head.appendChild(style);
  }

  function initialiseTabs() {
    var source = document.getElementById('readmore-book-details-source');
    var additionalPanel = document.getElementById('block-readmore_additional_information-content');

    if (source && additionalPanel && additionalPanel.dataset.readmoreBookDetails !== '1') {
      additionalPanel.innerHTML = source.innerHTML;
      additionalPanel.dataset.readmoreBookDetails = '1';
    }

    var reviewsPanel = document.querySelector('#block-readmore_reviews-content .spr-reviews');
    if (reviewsPanel && !reviewsPanel.textContent.trim()) {
      reviewsPanel.innerHTML = '<p class="readmore-reviews-empty">Nog geen reviews beschikbaar.</p>';
    }

    document.querySelectorAll('.ap-productmeta__reviews-badge').forEach(function (link) {
      if (link.dataset.readmoreReviewsTab === '1') return;
      link.dataset.readmoreReviewsTab = '1';
      link.addEventListener('click', function (event) {
        var reviewTab = document.querySelector('[ap-controlsaria="block-readmore_reviews"]');
        if (!reviewTab) return;
        event.preventDefault();
        reviewTab.click();
        var tabs = document.querySelector('.product-content__tabs');
        if (tabs) tabs.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function init() {
    addStyles();
    initialiseTabs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
